import * as fetchAPI from '@/components/fetchService';
import * as constants from '@/constants';
import { AutoCompleteParams, SearchParams } from './data';
import { notification } from 'antd';

export async function fetchDisclosureFilters() {
  return fetchAPI.fetchAPIGET('/mhra_disclosurelog/api/filters/');
}

export async function autocomplete(params: AutoCompleteParams) {
  const res: any[] = [];
  const queryURL = '/mhra_disclosurelog/api/disclosures/';

  if (params.search.length >= 3) {
    const result: any = await fetchAPI.fetchAPIPOST(queryURL, params);
    if (result && result.status === 200) {
      result.value.forEach((i: any) => res.push(i));
    } else {
      notification.error({
        message: 'Error while suggesting MHRA inspection reports',
      });
      return null;
    }
  }

  return res
    .filter(
      (obj, pos, arr) =>
        arr.map(mapObj => mapObj['@search.text']).indexOf(obj['@search.text']) === pos,
    )
    .slice(0, constants.AutoCompleteRes);
}

export async function disclosureSearch(params: SearchParams) {
  return fetchAPI.fetchAPIPOST('/mhra_disclosurelog/api/disclosure_search/', params);
}

export async function fetchInspectionReportDetail(reportId: number | string) {
  return fetchAPI.fetchAPIGET(`/mhra_disclosurelog/api/disclosure_detail/?report_id=${reportId}`);
}
